import React, { Fragment } from 'react';
import TopNavigation from './components/topNavigation/TopNavigation';
import Header from './components/header/Header';
import DocumentUploadForm from './components/documentUploadForm/DocumentUploadForm';
import SchedulerForm from './components/scheduler/SchedulerForm';
import ActivateCardForm from './components/activateCard/ActivateCardForm';
import ChangePinForm from './components/changePin/ChangePinForm';
import AccountServicesForm from './components/accountServices/AccountServicesForm';

import './App.css';
import { BrowserRouter as Router, Switch, Route , Redirect} from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import DocumentUploadState from './context/DocumentUpload/DocumentUploadState';
import NotificationState from './context/Notification/NotificationState';

const THEME = createMuiTheme({
  typography: {
    fontFamily: `"NotoSansRegular","ROBOTO", "Helvetica", "Arial", sans-serif`,
  },
});
const mainFeaturedPost = {
  title: 'Online Account Opening Document Upload',
};
function App() {
    console.log('APP');
  //uncomment when needed
  /*------- CODE FOR DISABLING RIGHT CLICK FUCTIONALITY------ */
  /* document.oncontextmenu = () => {
    alert('Right click has been disabled on this function.');
    return false;
  };

  document.onkeydown = function (event) {
    if (event.keyCode === 123) {
      return false;
    } else if (
      (event.ctrlKey && event.shiftKey && event.keyCode === 73) ||
      (event.ctrlKey && event.shiftKey && event.keyCode === 74)
    ) {
      return false;
    }
  }; */
  // ------- CODE FOR DISABLING RIGHT CLICK FUCTIONALITY------
  return (
    <Router>
      <DocumentUploadState>
        <NotificationState>
          <Fragment>
            <ThemeProvider theme={THEME}>
              <CssBaseline />
              <TopNavigation />
              <Switch>
                <Route exact path='/DocumentUpload' component={DocumentUploadForm} />
                <Route exact path='/Scheduler' component={SchedulerForm} />
                <Route exact path='/ActivateCard' component={ActivateCardForm} />
                <Route exact path='/ChangePIN' component={ChangePinForm} />
                <Route exact path='/AccountServices' component={AccountServicesForm} />
                <Route path='*' exact={true} component={DocumentUploadForm} />
              </Switch>
            </ThemeProvider>
          </Fragment>
        </NotificationState>
      </DocumentUploadState>
    </Router>
  );
}

export default App;
